import type { MuteOnMessage } from '@module/types/centrifuge/public-message/muteMessageTypes';
import { create, type StateCreator } from 'zustand';

interface MuteState {
  muteTime: number; // 본인 채팅 금지 타임스탬프 저장용
  setMuteTime: (value: number) => void;
  muteOnMessages: MuteOnMessage[];
  setMuteOnMessages: (items: MuteOnMessage[]) => void;
  getMutedUsers: () => { [key: string]: number }; // 채팅 금지 권한자(BJ, 매니저)가 채팅 금지 된 유저들의 idx와 금지 시간 정보를 가져오기 위한 함수
  // 반환값 예시: { '123': 1700000000, '456': 1700003600 }
  deleteUserFromMutedUsers: (idx: string) => void; // 채팅 금지 권한자(BJ, 매니저)가 채팅 금지 해제를 시켰을 때, 목록에서 지우는 함수
}

const store: StateCreator<MuteState, [], [], MuteState> = (set, get) => ({
  muteTime: 0,
  setMuteTime: (value: number) => set(() => ({ muteTime: value })),
  muteOnMessages: [],
  setMuteOnMessages: (items: MuteOnMessage[]) => set(() => ({ muteOnMessages: items })),
  getMutedUsers: () => {
    const idxAndMuteTime: { [key: string]: number } = {};
    get().muteOnMessages.forEach((message) => {
      idxAndMuteTime[String(message.data.message.idx)] = message.data.message.muteTime;
    });

    return idxAndMuteTime;
  },
  deleteUserFromMutedUsers: (idx: string) =>
    set(() => ({
      muteOnMessages: get().muteOnMessages.filter((i) => String(i.data.message.idx) !== idx),
    })),
});

const useMuteStore = create<MuteState>()(store);

export default useMuteStore;
